import { createMutation, createTriggerResource } from '@magicdoorinc/ui';
import { createMagicDoorContext } from '~/contexts/utils';
import { ManagementFeesRepository } from '~/repositories/managementFeesRepository';
import type {
  AddManagementFeeCreditDto,
  ChartOfAccountDto,
  GetPaginatedManagementFeesParams,
  ManagementFeeCreditItemDto,
  PropertyDto,
} from '~/swagger/portal/Api';

const repo = new ManagementFeesRepository();

export const [PropertyCreditProvider, usePropertyCredit] = createMagicDoorContext('PropertyCredit', () => {
  const [filtered, setFilter, actions] = createTriggerResource(async (filter?: { page?: number; pageSize?: number }) => {
    const res = await repo.getManagementFeeCredits(filter);
    const items = res.items.map((item: ManagementFeeCreditItemDto) => {
      return {
        ...item,
        property: res.properties?.find((property: PropertyDto) => property.id === item.propertyId),
        chartOfAccountName: res.chartOfAccounts?.find((chartOfAccount: ChartOfAccountDto) => chartOfAccount.id === item.chartOfAccountId)
          ?.name,
      };
    });

    return {
      ...res,
      items,
    };
  });

  const addPropertyCredit = createMutation(async (_propertyId: string, payload: AddManagementFeeCreditDto) => {
    await repo.addManagementFeeCredit(payload);
    actions.refetch();
  });

  const deletePropertyCredit = createMutation(async (managementFeeCreditId: string) => {
    await repo.deleteManagementFeeCredit(managementFeeCreditId);
    actions.refetch();
  });

  return {
    filtered: filtered,
    setFilter: (filter: GetPaginatedManagementFeesParams) => setFilter(filter),
    addPropertyCredit,
    deletePropertyCredit,
  };
});
